import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/meater/app/clientProviders.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer","CartDrawer","Modals"] */ "/vercel/path0/apps/meater/src/components/layout/ClientLayoutComponents.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/meater/src/components/Navigation/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/meater/src/components/scrollToTop/ScrollToTop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StoreProvider"] */ "/vercel/path0/apps/meater/src/contexts/StoreProvider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.5.21_@babel+core@7.29.7_@opentelemetry+api@1.9.0_@playwright+test@1.58.2_react-dom@19_zsosce65cohmaevehgjb7lxplm/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/ui/src/components/CountryModal/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/ui/src/components/ErrorBoundary/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/ui/src/components/Seo/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/ui/src/context/CurrentUrlProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InternalTranslationProvider"] */ "/vercel/path0/packages/ui/src/context/Translation/context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UIProvider"] */ "/vercel/path0/packages/ui/src/modules/UI/index.ts");
